import { createSelector } from '@reduxjs/toolkit';

import { selectEntities } from '@/services/selectors';
import type { AppState } from '@/types';

const selectWhitelistEntities = createSelector(selectEntities, entities => entities.whitelist);

export const selectWhitelist = createSelector(selectWhitelistEntities, ({ byIds, ids }) => ids.map(id => byIds[id]));

export const selectWhitelistApi = (state: AppState) => state.api.whitelist.fetch;
